import {
  ChangeDetectionStrategy,
  Component,
  signal,
  inject,
} from '@angular/core';
import { Router } from '@angular/router';
import { AdminMenuItem } from '../../models';
import { adminMenuItems, adminRoutes } from '../../constants';
import { ModalService } from '@shared/services';

@Component({
  standalone: false,
  selector: 'gstar-admin-dashboard-page',
  templateUrl: './admin-dashboard-page.component.html',
  styleUrls: ['./admin-dashboard-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminDashboardPageComponent {
  private readonly router = inject(Router);
  private readonly modalService = inject(ModalService);

  public adminMenuItems = adminMenuItems;

  itemClick(item: AdminMenuItem): void {
    if (item.modalComponent) {
      this.modalService.open(item.modalComponent, {
        appModalId: signal(item.titleTranslateKey),
      });
    } else {
      this.router.navigate([adminRoutes.root, item.route]);
    }
  }
}
